"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var entrance_1 = require("../pages/entrance");
var notFound_1 = require("../pages/error/notFound");
var main_1 = require("../pages/main");
var apply_1 = require("../pages/main/apply");
var Form_1 = require("../pages/main/apply/Form");
var procedure_1 = require("../pages/procedure");
var check_1 = require("../pages/procedure/check");
var check_2 = require("../pages/main/apply/check");
var complete_1 = require("../pages/main/apply/complete");
var useTracking_1 = require("../common/hooks/useTracking");
var shops_1 = require("../pages/shops");
var category_1 = require("../pages/shops/categories/category");
var product_1 = require("../pages/shops/products/product");
var preview_1 = require("../pages/preview");
var news_1 = require("../pages/main/news");
var NewsDetails_1 = require("../pages/main/news/NewsDetails");
var isAuthPage = false; // 入場ページを利用するかどうか
/**
 * 認証済み：メインページへリダイレクト
 * (LocalStorageにTokenがある場合)
 */
var Authenticated = function (_a) {
    var children = _a.children;
    var location = (0, react_router_1.useLocation)();
    if (!isAuthPage)
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/main", state: { from: location } });
    if (localStorage.getItem("token")) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/main", state: { from: location } });
    }
    else {
        return children;
    }
};
/**
 * 未認証：ログインページへリダイレクト
 * (LocalStorageにTokenがない場合)
 */
var RequireAuth = function (_a) {
    var children = _a.children;
    var location = (0, react_router_1.useLocation)();
    if (!isAuthPage)
        return children;
    if (!localStorage.getItem("token")) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/", state: { from: location } });
    }
    else {
        return children;
    }
};
var Router = function () {
    var trackingElement = document.getElementById("stock");
    var trackingGaElement = document.getElementById("stock_ga");
    (0, useTracking_1.useTracking)(trackingElement === null || trackingElement === void 0 ? void 0 : trackingElement.dataset.stocks);
    (0, useTracking_1.useTracking)(trackingGaElement === null || trackingGaElement === void 0 ? void 0 : trackingGaElement.dataset.stocks);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(Authenticated, null,
                    react_1.default.createElement(entrance_1.Entrance, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/procedure", element: react_1.default.createElement(Authenticated, null,
                    react_1.default.createElement(procedure_1.Procedure, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/procedure/check", element: react_1.default.createElement(check_1.Check, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(main_1.Main, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/:path", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(main_1.Main, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/apply", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(apply_1.Apply, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/apply/form", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(Form_1.ApplyForm, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/apply/complete", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(complete_1.Complete, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/news", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(news_1.News, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/main/apply/check", element: react_1.default.createElement(check_2.Check, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(shops_1.Shop, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code/categories/:category_id", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(category_1.Category, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code/products/:product_id", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(product_1.Product, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code/:path", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(shops_1.Shop, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code/news", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(news_1.News, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/:shop_code/news/:news_id", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(NewsDetails_1.NewsDetails, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/preview/:content_template_id", element: react_1.default.createElement(RequireAuth, null,
                    react_1.default.createElement(preview_1.Preview, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(notFound_1.NotFound, null) }))));
};
exports.default = Router;
